
import React from "react";

function Home() {
  return (
    <section id="home" className="section">

      <h1>

        <span className="intro">Hi, I'm </span>
  <span className="myname">Logapriya B</span>
        </h1>
      <h2>  Aspiring  Full Stack Developer </h2> 
     

    <p className="home-text">Passionate about building modern web applications and learning new <br /> technologies. Currently focused on creating exceptional frontend <br/> experiences. </p>
     
     <a href="#contact" className="contact-btn">Get in touch</a>

    </section>
  );
}


export default Home;